import axios from 'axios';

const TermApi = {
  search: (params) => {
    return axios.get('terms/search/', { params });
  }
}

export default TermApi;